/*
 * Anchor scroll correction.
 *
 * App-rendered sections (Rivo loyalty blocks, etc.) inject their content after
 * the browser has already jumped to the URL hash, so the target moves and the
 * page lands in the wrong place. This re-aligns the target while the layout is
 * still settling, and offsets it below the sticky header.
 *
 * Stops as soon as the visitor scrolls, or once the layout goes quiet.
 */
(function () {
  'use strict';

  var SETTLE_MS = 400;
  var MAX_WAIT_MS = 6000;
  var STICKY_HEADER = '.global-header-b';

  function headerOffset() {
    var header = document.querySelector(STICKY_HEADER);
    if (!header) return 0;

    var position = window.getComputedStyle(header).position;
    if (position !== 'sticky' && position !== 'fixed') return 0;

    return header.getBoundingClientRect().height;
  }

  function align(hash) {
    var target;

    try {
      target = document.querySelector(decodeURIComponent(hash));
    } catch (error) {
      return;
    }
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'auto' });
  }

  function alignUntilSettled(hash) {
    var startedAt = Date.now();
    var settleTimer = null;
    var observer = null;
    var finished = false;

    function onLoad() {
      if (!finished) align(hash);
    }

    function stop() {
      if (finished) return;
      finished = true;

      if (observer) observer.disconnect();
      clearTimeout(settleTimer);

      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      window.removeEventListener('keydown', stop);
      window.removeEventListener('load', onLoad);
    }

    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
    window.addEventListener('keydown', stop);
    window.addEventListener('load', onLoad);

    align(hash);

    if (typeof ResizeObserver !== 'function') {
      settleTimer = setTimeout(stop, MAX_WAIT_MS);
      return;
    }

    observer = new ResizeObserver(function () {
      if (finished) return;

      if (Date.now() - startedAt > MAX_WAIT_MS) {
        stop();
        return;
      }

      align(hash);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(stop, SETTLE_MS);
    });

    observer.observe(document.body);
  }

  if (window.location.hash.length > 1) {
    alignUntilSettled(window.location.hash);
  }

  window.addEventListener('hashchange', function () {
    if (window.location.hash.length > 1) align(window.location.hash);
  });
})();
